<template>
  <div class="slider-controller">
    <button
      class="slider-controller__control-button slider-controller__control-button--back"
      :class="{'slider-controller__control-button--disabled': currentSlide === 0}"
      :disabled="props.currentSlide === 0"
      @click="props.slider?.prev()"
    >
      <div class="slider-controller__control-button-inner slider-controller__control-button-inner--desktop">
        <icon name="ArrowOutlineLeft" />
      </div>
      <div class="slider-controller__control-button-inner slider-controller__control-button-inner--mobile">
        <icon name="ArrowOutlineLeftMobile" />
      </div>
    </button>
    <button
      class="slider-controller__control-button slider-controller__control-button--forward"
      :class="{'slider-controller__control-button--disabled': props.currentSlide >= props.slider?.track.details.slides.length - props.displayedDays}"
      :disabled="props.currentSlide >= props.slider?.track.details.slides.length - props.displayedDays.value"
      @click="props.slider?.next()"
    >
      <div class="slider-controller__control-button-inner slider-controller__control-button-inner--desktop">
        <icon name="ArrowOutlineRight" />
      </div>
      <div class="slider-controller__control-button-inner slider-controller__control-button-inner--mobile">
        <icon name="ArrowOutlineRightMobile" />
      </div>
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  currentSlide: any,
  slider: any,
  displayedDays: any
}>()

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.slider-controller {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--grid-gutter);

  &__control-button {
    @include tools.button-borderless;
    display: flex; // stylelint-disable-line
    padding: 0;
    border: 0;
    box-shadow: none;

    &:hover {
      color: var(--color-black);
      background-color: transparent;
    }

    &--disabled {
      display: none;
      cursor: not-allowed;
    }

    &--back {
      &::after {
        transform: rotate(180deg);
      }
    }

    &--forward {
      justify-self: flex-end;
      margin-left: auto;
    }
  }

  &__control-button-inner {
    &--desktop {
      @include tools.to(tools.$breakpoint--desktop) {
        display: none;
      }
    }

    &--mobile {
      @include tools.from(tools.$breakpoint--desktop) {
        display: none;
      }
    }
  }
}
</style>
